
import {
    OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_EN_CURS,
    OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_FINALITZADA,
    OBSERVACIO_INICIALITZAR,
    OBSERVACIO_FORMULARI_INICIALITZAR
} from '../../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioObtenirFormulariEnCurs = (state = ESTAT_INICIAL, action) => {

    switch (action.type) {
        case OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_EN_CURS:
            return true;
        case OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_FINALITZADA:
            return false;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL;
        case OBSERVACIO_FORMULARI_INICIALITZAR:
            return ESTAT_INICIAL;
        default:
            return state;
    }
};

export default peticioObtenirFormulariEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/peticioObtenirFormulariEnCurs.js